import {
  ReportInformation,
  ReportSubsystem,
  ReportSystem,
  TemplateSubsystem,
  TemplateSystem,
} from '../../types';

export * from './information';

export const HOME_INSPECTION_DETAILS_NAME = 'Home Inspection Details';

type SystemOrSubsystemOrInformation = ReportSystem | ReportSubsystem | ReportInformation;

export const sortByDisplayIndex = (
  items: SystemOrSubsystemOrInformation[] | null = [],
) => [...(items || [])].sort(
  (a: SystemOrSubsystemOrInformation, b: SystemOrSubsystemOrInformation) => {
    if ('name' in a) {
      if (a.name === HOME_INSPECTION_DETAILS_NAME) return -1;
    }
    if ('name' in b) {
      if (b.name === HOME_INSPECTION_DETAILS_NAME) return 1;
    }

    if (a.displayIndex === b.displayIndex) return 0;
    if (a.displayIndex === null) return -1;
    if (b.displayIndex === null) return 1;
    if (a.displayIndex < b.displayIndex) return -1;
    if (a.displayIndex > b.displayIndex) return 1;
    return 0;
  },
);

export const sortReportSystemOrSubsystemByDisplayIndex = sortByDisplayIndex;

export const sortTemplateSystemOrSubsystemByDisplayIndex = (
  items: (TemplateSystem | TemplateSubsystem)[],
) => [...items].sort((a, b) => {
  if (a.displayIndex === b.displayIndex) return 0;
  if (a.displayIndex === null) return -1;
  if (b.displayIndex === null) return 1;
  if (a.displayIndex < b.displayIndex) return -1;
  if (a.displayIndex > b.displayIndex) return 1;
  return 0;
});
